module.exports = "/_next/static/images/7b1c028ee69d079903e2fd6a03d65442-bars-xs.jpg";